"use client";

import { c as _c } from "react/compiler-runtime";
import { LinkOne, Share } from "@icon-park/svg";
import { Icon } from "@justhome/react-ui";
import { useState, useSyncExternalStore } from "react";

// Support for the share sheet does not change while the page is open.
const subscribe = () => () => {};
const BUTTON = "inline-flex items-center gap-2xs text-body-2 font-book text-neutral-425 hover:text-primary-800 transition-colors bg-transparent border-none p-none cursor-pointer focusable";
const ShareRow = t0 => {
  const $ = _c(13);
  const {
    title,
    labels
  } = t0;
  const canShare = useSyncExternalStore(subscribe, _temp, _temp2);
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      try {
        await navigator.clipboard.writeText(location.href);
        setCopied(true);
      } catch {}
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const copy = t1;
  let t2;
  if ($[1] !== title) {
    t2 = async () => {
      try {
        await navigator.share({
          title,
          url: location.href
        });
      } catch {}
    };
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const share = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon={LinkOne} size={16} className="flex" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = copied ? labels.copied : labels.copy;
  let t5;
  if ($[4] !== t4) {
    t5 = <button type="button" onClick={copy} data-tracking-event="Article - Copy Link" className={BUTTON}>{t3}<span aria-live="polite">{t4}</span></button>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== canShare || $[7] !== labels.share || $[8] !== share) {
    t6 = canShare && <button type="button" onClick={share} data-tracking-event="Article - Share" className={BUTTON}><Icon icon={Share} size={16} className="flex" />{labels.share}</button>;
    $[6] = canShare;
    $[7] = labels.share;
    $[8] = share;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="mt-2m flex flex-wrap items-center gap-m">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default ShareRow;
function _temp() {
  return typeof navigator.share === "function";
}
function _temp2() {
  return false;
}